import React, { Component } from "react";
import image from "../../../assets/images/callgage-seo-header.png";
import "../../../styles/pages/seo/SEOHeader.css";

export default class SEOHeader extends Component {
  render() {
    return (
      <div className="SEOHeader gutters on-scroll-anim">
        {/* Mobile Title */}
        <div className="title-container mobile">
          <div className="word-container">
            <div className="word">SEO</div>
          </div>
          <div className="word-container">
            <div className="word">SERVICES</div>
          </div>
        </div>

        {/* The Artwork */}
        <img src={image} alt="SEO data analysis." />

        {/* Desktop Title */}
        <div className="title-container desktop">
          <div className="word-container">
            <div className="word">SEO</div>
          </div>
          <div className="word-container">
            <div className="word">SERVICES</div>
          </div>
        </div>

        <div className="g-sub-text">
          We provide SEO services to help our clients get more traffic to their
          website.
        </div>
      </div>
    );
  }
}
